import { Capacitor } from "@capacitor/core"
import { Device } from "@capacitor/device"
import Detector from "./lib/detector"

const ENV = import.meta.env.MODE
const VIBRATO_FRONTEND_HOST = import.meta.env.VITE_VIBRATO_FRONTEND_HOST || "localhost:3000"
const VIBRATO_FRONTEND_PROTOCOL = import.meta.env.VITE_VIBRATO_FRONTEND_PROTO || "http"
const VIBRATO_API_HOST = import.meta.env.VITE_VIBRATO_API_HOST || "localhost:8000"
const VIBRATO_API_PROTOCOL = import.meta.env.VITE_VIBRATO_API_PROTO || "http"
const VIBRATO_WS_API_PROTOCOL = import.meta.env.VITE_VIBRATO_WS_API_PROTO || "ws"
const VIBRATO_FRONTEND_URL = `${VIBRATO_FRONTEND_PROTOCOL}://${VIBRATO_FRONTEND_HOST}`
const VIBRATO_CONTENT_URL = import.meta.env.VITE_VIBRATO_CONTENT_URL || "http://localhost:3001/"

// TODO: support https
const VIBRATO_API_HOST_URL = `${VIBRATO_API_PROTOCOL}://${VIBRATO_API_HOST}`
const VIBRATO_WS_URL = `${VIBRATO_WS_API_PROTOCOL}://${VIBRATO_API_HOST}`

const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN as string
const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID as string
const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE as string

const AUTH0_MOBILE_CLIENT_ID =
  (import.meta.env.VITE_AUTH0_MOBILE_CLIENT_ID as string) || "uUc3RyX3Q6VxaFnX59msO4J9lf1kzqAT"
const AUTH0_MOBILE_AUDIENCE = AUTH0_AUDIENCE

const SENTRY_ENV = ENV

const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN || "11111111111111111111111111111111"

const USE_CSV_IMPORTER_KEY = import.meta.env.VITE_USE_CSV_IMPORTER_KEY || "7039b71d-baf2-47a3-b0f1-95e60278c123"

const LIVEKIT_URL = import.meta.env.VITE_LIVEKIT_URL || "wss://vibrato-dev-on4b1dzp.livekit.cloud"

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || "G-NA"

const FACEBOOK_PIXEL_ID = import.meta.env.VITE_FACEBOOK_PIXEL_ID || "1234567890"

const DEMO_PHONE_NUMBER = "+1 (866) 722-4682"
const DEMO_PHONE_NUMBER_TEL = "+18667224682"

const IS_NATIVE_APP = Capacitor.isNativePlatform()

const getPlatformFromUrl = (): string | null => {
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get("platform")
  }
  return null
}

const PLATFORM = getPlatformFromUrl() || Capacitor.getPlatform()

const IS_ANDROID = PLATFORM === "android"
const IS_IOS = PLATFORM === "ios"
const IS_MOBILE_SAFARI = Detector.isMobileSafari()

export let NATIVE_DEVICE_ID = ""
if (IS_NATIVE_APP) {
  Device.getId().then((id) => {
    NATIVE_DEVICE_ID = id.identifier
    console.log(`NATIVE_DEVICE_ID: ${NATIVE_DEVICE_ID}`)
  })
}

// Check if URL has native=1 param
const hasNativeParam = () => {
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get("native") === "1"
  }
  return false
}

const SHOW_NATIVE_APP = IS_NATIVE_APP || hasNativeParam()

let ENABLE_RELOAD_ON_NEW_PLAN = true

console.log("Settings")
console.log(`ENV: ${ENV}`)
console.log(`VIBRATO_URL: ${VIBRATO_API_HOST_URL}`)
console.log(`VIBRATO_WS_URL: ${VIBRATO_WS_URL}`)
console.log(`VIBRATO_FRONTEND_HOST: ${VIBRATO_FRONTEND_HOST}`)
console.log(`VIBRATO_FRONTEND_URL: ${VIBRATO_FRONTEND_URL}`)
console.log(`AUTH0_DOMAIN: ${AUTH0_DOMAIN}`)
console.log(`AUTH0_CLIENT_ID: ${AUTH0_CLIENT_ID}`)
console.log(`AUTH0_MOBILE_CLIENT_ID: ${AUTH0_MOBILE_CLIENT_ID}`)
console.log(`AUTH0_AUDIENCE: ${AUTH0_AUDIENCE}`)
console.log(`AUTH0_MOBILE_AUDIENCE: ${AUTH0_MOBILE_AUDIENCE}`)
console.log(`SENTRY_ENV: ${SENTRY_ENV}`)
console.log(`IS_NATIVE_APP: ${IS_NATIVE_APP}`)
console.log(`SHOW_NATIVE_APP: ${SHOW_NATIVE_APP}`)
console.log(`ENABLE_RELOAD_ON_NEW_PLAN: ${ENABLE_RELOAD_ON_NEW_PLAN}`)
console.log(`IS_ANDROID: ${IS_ANDROID}`)
console.log(`IS_IOS: ${IS_IOS}`)
console.log(`IS_MOBILE_SAFARI: ${IS_MOBILE_SAFARI}`)
console.log(`PLATFORM: ${PLATFORM}`)
console.log(`GA_MEASUREMENT_ID: ${GA_MEASUREMENT_ID}`)
console.log(`FACEBOOK_PIXEL_ID: ${FACEBOOK_PIXEL_ID}`)

export const settings = {
  ENV: ENV,
  VIBRATO_FRONTEND_HOST: VIBRATO_FRONTEND_HOST,
  VIBRATO_FRONTEND_URL: VIBRATO_FRONTEND_URL,
  VIBRATO_URL: VIBRATO_API_HOST_URL,
  VIBRATO_WS_URL: VIBRATO_WS_URL,
  AUTH0_DOMAIN: AUTH0_DOMAIN,
  AUTH0_CLIENT_ID: AUTH0_CLIENT_ID,
  AUTH0_AUDIENCE: AUTH0_AUDIENCE,
  AUTH0_MOBILE_CLIENT_ID: AUTH0_MOBILE_CLIENT_ID,
  AUTH0_MOBILE_AUDIENCE: AUTH0_MOBILE_AUDIENCE,
  SENTRY_ENV: SENTRY_ENV,
  MIXPANEL_TOKEN: MIXPANEL_TOKEN,
  USE_CSV_IMPORTER_KEY: USE_CSV_IMPORTER_KEY,
  LIVEKIT_URL: LIVEKIT_URL,
  IS_NATIVE_APP: IS_NATIVE_APP,
  SHOW_NATIVE_APP: SHOW_NATIVE_APP,
  ENABLE_RELOAD_ON_NEW_PLAN: ENABLE_RELOAD_ON_NEW_PLAN,
  IS_ANDROID: IS_ANDROID,
  IS_IOS: IS_IOS,
  IS_MOBILE_SAFARI: IS_MOBILE_SAFARI,
  PLATFORM: PLATFORM,
  GA_MEASUREMENT_ID: GA_MEASUREMENT_ID,
  FACEBOOK_PIXEL_ID: FACEBOOK_PIXEL_ID,
  DEMO_PHONE_NUMBER: DEMO_PHONE_NUMBER,
  DEMO_PHONE_NUMBER_TEL: DEMO_PHONE_NUMBER_TEL,
  VIBRATO_CONTENT_URL: VIBRATO_CONTENT_URL
}
